export default "__VITE_ASSET__11503cd5__"